import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { HTTP } from 'src/app/services/http';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'apitest',
  imports: [CommonModule],
  templateUrl: './apitest.html',
  styleUrl: './apitest.sass'
})
export class Apitest {
  tickets: any = null;
  studios: any = null;
  baseUrl: string = environment.apiUrl;

  constructor() {}

  async testTickets() {
    try {
      const response = await HTTP.get(`ticket`);
      this.tickets = response;
    } catch (error) {
      this.tickets = error;
    }
  }

  async testStudios() {
    try {
      const response = await HTTP.get(`studio`);
      this.studios = response;
    } catch (error) {
      this.studios = error;
    }
  }

  async testDownloadFile() {
    // Example: download first file from first ticket

    const response = await HTTP.get(`ticket`);
    if (response.tickets && response.tickets.length > 0 && response.tickets[0].files && response.tickets[0].files.length > 0) {
      const file = response.tickets[0].files[0];
      const fileId = file.id;
      const filename = file.filename || 'downloaded_file';
      try {
        const blob = await HTTP.get<Blob>(`ticket-file/${fileId}`, {
          responseType: 'blob'
        });
        // Create a temporary link and trigger download
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = filename;
        document.body.appendChild(a);
        a.click();
        setTimeout(() => {
          document.body.removeChild(a);
          window.URL.revokeObjectURL(url);
        }, 100);
      } catch (err) {
        this.tickets = err;
      }
    } else {
      this.tickets = 'No files found.';
    }
  }

}
